export function resolveWorkflowTabId(workflowIds: readonly string[], selectedId?: string): string {
    if (selectedId && workflowIds.includes(selectedId)) return selectedId;
    return workflowIds[0] || "";
}
